import Vue from "vue";
const vm = new Vue()

export const getListAgent = async () => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + "/shippop/agents" , {
            headers: {
                Token: localStorage.getItem("access_token")
            }
            }).then( res => {
                if (!res.data.status) {   
                    reject(res.data.error.msg);
                }
                resolve(res.data.data)
            })
    })
}

export const getOneAgent = async ( idAgent ) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .get(vm.$API_URL + `/shop/agent/${idAgent}`, {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            })
            .then(res => {
                if (!res.data.status) {   
                    if( res.data.error.hasOwnProperty("notices") ){
                        reject(res.data.error.notices);
                    }else{
                        reject(res.data.error.msg);
                    }
                }
                resolve(res.data.data)
            })
    })
}

export const getReceiptInfoAgent = async ( idAgent ) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .get(vm.$API_URL + `/shop/receiptInfo/${idAgent}`, {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            })
            .then(res => {
                if (!res.data.status) {   
                    reject(res.data.error.msg);
                }
                resolve(res.data.data)
            })
    })
}

export const updateAgent = async ( agent , idAgent ) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .put(
                vm.$API_URL + `/shop/agent/${idAgent}`,
                {
                    name: agent.name,
                    email: agent.email,
                    password: agent.password,
                    addCouriers: agent.selectedCourier,
                    wallet_open: agent.walletOpen,
                    pgw_public_key: agent.pgwPublicKey,
                    pgw_private_key: agent.pgwPrivateKey,
                    payment_type: agent.paymentType,
                    payment_condition: agent.paymentCondition,
                    sale_id: agent.sale.saleId
                },
                {
                    headers: { Token: localStorage.getItem("access_token") }
                }
            )
            .then(res => {
                if (!res.data.status) { 
                    if( res.data.error.hasOwnProperty("notices") ){
                        reject(res.data.error.notices);
                    }else{
                        reject(res.data.error);
                    }
                }
                resolve(res.data.data)
            })
    });
}

export const updateReceiptInfoAgent = async ( receiptInfo , idAgent ) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('type', receiptInfo.receiptType);
        formData.append('email', receiptInfo.receiptEmail);
        formData.append('tel', receiptInfo.tel);
        formData.append('name', receiptInfo.receiptName );
        formData.append('company_name', receiptInfo.companyName );
        formData.append('tax_id', receiptInfo.tax_id );
        formData.append('address', receiptInfo.address );
        formData.append('state', receiptInfo.state );
        formData.append('district', receiptInfo.district );
        formData.append('province', receiptInfo.province );
        formData.append('postcode', receiptInfo.postcode );
        formData.append('vat', receiptInfo.vat );
        formData.append('signature_name', receiptInfo.signatureName );

        if(  receiptInfo.logo.file != null ){
            formData.append('logo',  receiptInfo.logo.file);
        }

        if( receiptInfo.signature.file != null ){
            formData.append('signature_url',  receiptInfo.signature.file);
        }

        vm.$http
            .post(
                vm.$API_URL + `/shop/receiptInfo/${idAgent}`,
                formData,
                {
                    headers: {
                        Token: localStorage.getItem("access_token"),
                    },
                }
            )
            .then((res) => {
                let data = res.data.data;
                if (!res.data.status) {   
                    if( res.data.error.hasOwnProperty("notices") ){
                        reject(res.data.error.notices);
                    }else{
                        reject(res.data.error.msg);
                    }
                }
                resolve(data);
            });
    })
}